import { useQuery } from '@tanstack/react-query';

import { API_URLS } from '@/shared/api/main';

import { TCastingsClassifiers, TClassifiers } from '@/shared/types/classifiers';

import { getCastingsClassifiers } from '../api/getCastingsClassifiers';
import { getClassifiers } from '../api/getClassifiers';

/**
 * Хук для получения классификаторов
 * @returns Объект с общими классификаторами и классификаторами кастингов
 */
export const useGetClassifiers = () => {
  // Запрос общих классификаторов
  const generalQuery = useQuery<TClassifiers>({
    queryKey: [API_URLS.registration.classifiers],
    queryFn: getClassifiers,
    staleTime: Infinity, // Данные никогда не устаревают
    gcTime: Infinity, // Кэш никогда не очищается
    refetchOnMount: false, // Не делать запрос при монтировании
    refetchOnWindowFocus: false, // Не делать запрос при фокусе окна
    refetchOnReconnect: false // Не делать запрос при переподключении
  });
  // Запрос классификаторов кастингов
  const castingsQuery = useQuery<TCastingsClassifiers>({
    queryKey: [API_URLS.castings.classifiers],
    queryFn: getCastingsClassifiers,
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
  return {
    generalClassifiers: generalQuery.data,
    castingsClassifiers: castingsQuery.data,
    isLoading: generalQuery.isLoading || castingsQuery.isLoading,
    error: generalQuery.error || castingsQuery.error,
    refetchCastingsClassifiers: castingsQuery.refetch
  };
};
